module.exports = __webpack_public_path__ + "static/img/product1.7922c110.png";